<template>
  <!-- 対応記録 -->
  <b-modal :active="value" has-modal-card @close="close()">
    <form action>
      <div class="modal-card" style="width: 800px">
        <header class="modal-card-head">
          <p class="modal-card-title" style="color: whitesmoke">対応記録</p>
        </header>

        <section class="modal-card-body">
          <b-field label="対応内容" labelPosition="on-border">
            <b-input
              type="textarea"
              name="content"
              data-vv-as="対応内容"
              v-validate="'max:512'"
              maxlength="512"
              v-model="data.content"
            ></b-input>
          </b-field>

          <b-field label="対応結果" labelPosition="on-border">
            <b-input
              type="textarea"
              name="result"
              data-vv-as="対応結果"
              v-validate="'max:512'"
              maxlength="512"
              v-model="data.result"
            ></b-input>
          </b-field>
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="save">決定</button>
          <button class="button" type="button" @click="close()">閉じる</button>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
export default {
  props: ["disasterSupport", "value"],

  components: {},

  data() {
    let data = JSON.parse(JSON.stringify(this.disasterSupport));
    return {
      data,
    };
  },

  computed: {},

  filters: {},

  methods: {
    save: function() {
      this.$emit("disaster-support-event", this.data);
      this.close();
    },
    close: function() {
      this.$emit("input", false);
      return;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/DisasterSupport.vue